import { createContext } from 'react';
import { FormContextType } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FormContext = createContext<FormContextType<any>>({
  prefix: '',
  errors: {},
  value: {},
} as unknown as FormContextType);
